<script setup lang="ts">
import { useSpace } from "@/api/space-query";
import Scope from "./Scope.vue";

const props = defineProps({
	id: { type: String, required: true },
});

const { space } = useSpace(computed(() => props.id || ""));
</script>

<template>
	<Scope :name="space?.name" :image="space?.logoUrl" />
</template>
